__turbopack_context__.v({
  "banner": "banner-component-module-scss-module__W5q9Xa__banner",
  "banner--context-flex-grid": "banner-component-module-scss-module__W5q9Xa__banner--context-flex-grid",
  "banner__button": "banner-component-module-scss-module__W5q9Xa__banner__button",
  "banner__buttons": "banner-component-module-scss-module__W5q9Xa__banner__buttons",
  "banner__headline": "banner-component-module-scss-module__W5q9Xa__banner__headline",
  "banner__headline-wrapper": "banner-component-module-scss-module__W5q9Xa__banner__headline-wrapper",
  "banner__link": "banner-component-module-scss-module__W5q9Xa__banner__link",
  "banner__sub-headline": "banner-component-module-scss-module__W5q9Xa__banner__sub-headline",
});
